// extracted by mini-css-extract-plugin
export default {"container":"FeedDayHeader_container__M0Jg1","removeTopPadding":"FeedDayHeader_removeTopPadding__y81iX"};